import { DateRangeInput, EmployeeOrderBy, TodoType } from "@acto/gql/graphql";
import { TeamEmployee, TeamKpiSummary } from "@acto/taskpane/core/domain";
import { type PreviousDateRange, type RegionGroup, useTeamEmployees } from "./useTeamEmployees";

interface UseTeamKpisOptions {
  dateRange: DateRangeInput;
  pageSize?: number;
  orderBy?: EmployeeOrderBy;
  searchTerm?: string;
  todoTypes?: TodoType[];
  withAppointmentStates?: boolean;
}

interface UseTeamKpisResult {
  teamKpis?: TeamKpiSummary;
  employees: TeamEmployee[];
  isFetching: boolean;
  isPending: boolean;
  error?: Error;
  hasNextPage: boolean;
  fetchNextPage: () => void;
  previousRange?: PreviousDateRange;
  regionGroups?: RegionGroup[];
}

export function useTeamKpis({
  dateRange,
  pageSize = 10,
  orderBy,
  searchTerm,
  todoTypes,
  withAppointmentStates,
}: UseTeamKpisOptions): UseTeamKpisResult {
  const {
    data: employees,
    totals,
    previousRange,
    isFetching,
    isPending,
    error,
    hasNextPage,
    fetchNextPage,
    regionGroups,
  } = useTeamEmployees({
    dateRange,
    pageSize,
    orderBy,
    searchTerm,
    todoTypes,
    withAppointmentStates,
    groupByRegion: true,
  });

  return {
    teamKpis: totals,
    employees: employees ?? [],
    isFetching,
    isPending,
    error: error as Error | undefined,
    hasNextPage,
    fetchNextPage,
    previousRange,
    regionGroups,
  };
}
